export default "__VITE_ASSET__Ba3rtoQp__"